import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';

const documentTypeOptions = [
  { value: '01', label: 'Invoice' },
  { value: '02', label: 'Credit Note' },
  { value: '03', label: 'Debit Note' },
  { value: '04', label: 'Refund' },
  { value: '11', label: 'Self Billed Invoice' },
  { value: '12', label: 'Self Billed Credit Note' },
  { value: '13', label: 'Self Billed Debit Note' },
  { value: '14', label: 'Self Billed Refund' },
];

const DocumentTypeSelect = ({ name, label = 'Document Type', control, errors, readOnly = false }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...field}
          id={name}
          options={documentTypeOptions}
          readOnly={readOnly}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              error={!!errors[name]}
              helperText={errors[name]?.message}
              size="small"
              fullWidth
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
          onChange={(_, value) => field.onChange(value)}
          value={field.value || null} // handle default value
          getOptionLabel={(option) => option.label || ''}
        />
      )}
    />
  );
};

export default DocumentTypeSelect;
